import {
  GET_CONTRACTORS_TYPES,
  GET_SUPPLIER_TYPES,
  SUCCESS,
  FAIL,
} from "../action_types";

const STATE_INIT = {
  isLoading: false,
  isUpdating: false,
  contractorTypes: [],
  supplierTypes: [],
  error: {},
};

export default (state = STATE_INIT, { type, payload }) => {
  switch (type) {
    case GET_CONTRACTORS_TYPES:
      return { ...state, isLoading: true };
    case `${GET_CONTRACTORS_TYPES}_${SUCCESS}`:
      return {
        ...state,
        isLoading: false,
        contractorTypes: [...payload],
      };
    case `${GET_CONTRACTORS_TYPES}_${FAIL}`:
      return { ...state, isLoading: false, error: { ...payload } };

    case GET_SUPPLIER_TYPES:
      return { ...state, isLoading: true };
    case `${GET_SUPPLIER_TYPES}_${SUCCESS}`:
      return {
        ...state,
        isLoading: false,
        supplierTypes: [...payload],
      };
    case `${GET_SUPPLIER_TYPES}_${FAIL}`:
      return { ...state, isLoading: false, error: { ...payload } };

    default:
      return state;
  }
};
